import { Sparkles } from 'lucide-react';
import { cn } from '@/shared/lib/cn';

export type ScoreBadgeProps = {
  score: number;
  altoPotencial?: boolean;
  className?: string;
};

export const ScoreBadge = ({ score, altoPotencial = false, className }: ScoreBadgeProps) => {
  if (altoPotencial) {
    return (
      <span
        className={cn(
          'inline-flex items-center gap-1.5 rounded-full bg-[#ECFDF3] px-2.5 py-1 text-xs font-semibold text-[#067647]',
          className,
        )}
      >
        <Sparkles className="h-3 w-3" aria-hidden />
        Alto Potencial · {score}
      </span>
    );
  }
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border border-border bg-background px-2.5 py-1 text-xs font-semibold text-foreground',
        className,
      )}
    >
      Match · {score}
    </span>
  );
};
